import React from "react";
import { Link } from "react-router-dom";

const NotFoundView = () => (
  <div className="fable:text-center">
    <h1 className="cb-c-not-found-view__error-message"> Page not found </h1>
    {"Return "} <Link to="/">Home</Link>
  </div>
);
export default NotFoundView;
